<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Report" sub-title="Nilai Peserta Berdasarkan Materi" @back="back">
            <common-training-header :withLocation="true"/>
        </a-page-header>

        <a-row style="margin-bottom: 20px;">
            <a-col class="text-right">
                <download-excel :data="excel" name="classical-scores-material-breakdown.xls">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.scores" rowKey="hash" :pagination="false" bordered :scroll="{x: true}">
                    <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                        <h3 slot-scope="t,r,i" class="text-center">
                            {{ i + 1 }}
                        </h3>
                    </a-table-column>

                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="attendant" title="Nama" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> {{ record.name }} <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column-group v-for="(m,i) in items.materials" :key="'material-' + m.id" class="column-score">
                        <span slot="title" :title="m.name">
                            <strong>{{ i + 1}}</strong>
                        </span>
                        <a-table-column title="RSM" :key="'material-res-' + m.id" :width="100" class="align-center text-center text-small">
                            <template slot-scope="record">
                                <h3>{{ record.breakdown[m.id].RSM }}</h3>
                            </template>
                        </a-table-column>
                        <a-table-column title="EXM" :key="'material-exm-' + m.id" :width="100" class="align-center text-center text-small">
                            <template slot-scope="record">
                                <h3>{{ record.breakdown[m.id].EXM }}</h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>
<script>
export default {
    computed: {
        excel() {
            let excel = []
            let vm = this
            if (this.loading)
                return excel

            this.items.scores.forEach(function (i, n) {
                let item = {}
                let total = 0
                let divider = 0

                item['no'] = n +1
                item['name'] = i.name

                vm.items.materials.forEach(function(m) {

                    item[`RES: ${m.name}`] = parseFloat(i.breakdown[m.id].RSM).toFixed(2)
                    item[`EXM: ${m.name}`] = parseFloat(i.breakdown[m.id].EXM).toFixed(2)
                    item[`TOT: ${m.name}`] = (parseFloat(item[`RES: ${m.name}`]) + parseFloat(item[`EXM: ${m.name}`])).toFixed(2)
                    total = (parseFloat(total) + parseFloat(item[`TOT: ${m.name}`])).toFixed(2)

                    if (item[`TOT: ${m.name}`])
                        divider++
                })

                item['AVG SCORE'] = (total / divider).toFixed(2)

                excel.push(item)
            })

            return excel
        }
    },
    created() {
        this.getItems()
    },
    data() {
        return {
            loading: false,
            items: []
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http.get(this.routeUri('api.report.classical.material-breakdown'))
                .then( (r) => this.items =  r.data)
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.loading = false)
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    }
}
</script>
